module.exports = "/_next/static/images/FrameMobile-1c99a9f38dfed20fcb47300620dd4b90.png";